import { render } from "./FilterRkapYear.vue?vue&type=template&id=392487d3"
import script from "./FilterRkapYear.vue?vue&type=script&lang=js"
export * from "./FilterRkapYear.vue?vue&type=script&lang=js"
script.render = render

export default script